module.exports = __webpack_public_path__ + "static/kvm_2.9e294b4f.jpg";